<div class="card">
  <div class="card-body">
    <h4 class="card-title"><span class="lstick"></span>Monitoring</h4>
    <div style="height: 220px;">
      <canvas
        baseChart
        height="100px"
        [data]="doughnutChartData"
        [labels]="doughnutChartLabels"
        [options]="doughnutChartOptions"
        [legend]="doughnutChartLegend"
        [chartType]="doughnutChartType"
        [colors]="[
          {
            backgroundColor: [
            'rgb(38, 198, 218)',
              'rgb(116, 90, 242)',
              'rgb(30, 136, 229)'
            ]
          }
        ]"
      >
      </canvas>
    </div>
    <table class="table vm font-14">
      <tr>
        <td class="b-0" style="cursor: pointer; text-decoration: underline; color: rgb(38, 198, 218);" (click)="openMonitorDialog()">Monitored Units</td>
        <td class="text-right font-medium b-0">{{doughnutChartData[0]?doughnutChartData[0]:"NA"}}</td>
      </tr>
      <tr>
        <td  style="cursor: pointer; text-decoration: underline; color: rgb(116, 90, 242);" (click)="openUnMonitorDialog()">UnMonitored Units</td>
        <td class="text-right font-medium">{{doughnutChartData[1]?doughnutChartData[1]:"NA"}}</td>
      </tr>
      <tr>
        <td>Total No. of Units</td>
        <td class="text-right font-medium">{{doughnutChartData[1]+doughnutChartData[0]?doughnutChartData[1]+doughnutChartData[0]:"NA"}}</td>
      </tr>
    </table>
  </div>
</div>

